import { usePatientProfile } from 'apps/wrapper/src/hooks/use-patient-profile';
import { FC, useMemo } from 'react';
import { AllCommunicationSection, CommunicationSubSection, Section, SelectAllSection, Separator } from './comm-preferences.styles';


type CommPreferencesPhoneViewProps = {
  setChange: (key: string, value: any) => void;
  changes: any;
};

export const CommPreferencesPhoneView: FC<CommPreferencesPhoneViewProps> = ({ setChange, changes }) => {
  const { patientPreferences } = usePatientProfile();

  const localPreferences = useMemo(
    () => changes.updateLocalPreferences || patientPreferences,
    [patientPreferences, changes]
  );

  const updateLocalPreferences = (state: Partial<typeof patientPreferences>) => {
    const newState = { ...patientPreferences, ...changes.updateLocalPreferences, ...state };

    setChange('updateLocalPreferences', newState);
  };

  return (
    <div>
      <Section>
        <Separator>Essential Communications</Separator>
        <CommunicationSubSection
          text="Appointment Reminders"
          isChecked={localPreferences.pcAppointmentConfirmations}
          onChange={(value) => updateLocalPreferences({ pcAppointmentConfirmations: value })}
        />
      </Section>
    </div>
  );
};
